import React from 'react';
import { graphql, usePreloadedQuery, type EntryPointProps } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { Nav4ProjectsContent } from '../../../../common/ui/content/Nav4ProjectsContent.tsx';
import type { Nav4ProjectsContentViewQuery } from './__generated__/Nav4ProjectsContentViewQuery.graphql';

type Queries = { projects: Nav4ProjectsContentViewQuery };

export function Nav4ProjectsContentViewQuery({
	queries: { projects },
}: EntryPointProps<Queries, {}, Partial<EntryPointRouteParams>, {}>): React.JSX.Element {
	const data = usePreloadedQuery<Nav4ProjectsContentViewQuery>(
		graphql`
			query Nav4ProjectsContentViewQuery($cloudId: ID!, $entityAriProjects: ID!, $ownerAri: ID)
			@preloadable {
				...Nav4ProjectsContent
			}
		`,
		projects,
	);

	return <Nav4ProjectsContent queryRef={data} />;
}
